import React, { useState } from 'react';
import './Groups.less';
import { Modal } from 'antd';
import NewCustomButton from '../Common/NewCustomButton';
import { ButtonTypes } from '../Common/CustomButton';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { NewCloseIcon, NewUpdateIcon } from '../Common/Icons';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';

const GroupDeleteConfirmModal = ({
  showGroupDeleteConfirmModal,
  closeGroupDeleteConfirmModal,
  record,
  onActionClick,
  setRefreshGroupList,
  closeGroupModal,
}) => {
  const trans = useSelector(translator);
  const userGroupApi = useSelector((state) => state.apis.userGroupApi);
  const [isDeleting, setIsDeleting] = useState(false);

  const groupDeleteHandler = (useruuid) => {
    setIsDeleting(true);
    userGroupApi.deleteUserGroup(
      useruuid,
      apiCallback({
        translator: trans,
        failCallback: errorCallback,
        errorCallback,
        successCallback,
      })
    );
  };

  const errorCallback = (error) => {
    setIsDeleting(false);
    // message.error("Error deleting user group !");
    console.error('Error deleting user group:', error);
  };

  const successCallback = (data) => {
    setIsDeleting(false);
    onActionClick(null, null)();
    closeGroupDeleteConfirmModal();
    setRefreshGroupList((prev) => !prev);
    closeGroupModal();
  };

  return (
    <Modal
      open={showGroupDeleteConfirmModal}
      onOk={closeGroupDeleteConfirmModal}
      onCancel={closeGroupDeleteConfirmModal}
      footer={null}
      closable={false}
      centered
      className="group-modal-container"
      tabIndex={-1}
    >
      <div className="modal-container">
        {/* Header Section */}
        <div className="group-delete-modal-header-container">
          <div className="group-header-icon-title-new-container">
            <div className="group-modal-header-info">
              <div className="group-header-title-new">{trans('DELETEGROUP')}</div>
              <div className="group-header-sub-title">
                {trans('AREYOUSUREYOUWANTTOPERMANENTLYDELETETHEGROUP?')}
              </div>
            </div>
          </div>
        </div>
        {/* Footer Buttons */}
        <div className="modal-footer">
          <NewCustomButton
            className="cancel-form-icon"
            label={trans('CANCEL')}
            icon={<NewCloseIcon style={{ fill: '#113E57' }} />}
            onClick={closeGroupDeleteConfirmModal}
            disabled={isDeleting} // Disable cancel during deletion
          />
          <NewCustomButton
            disabled={isDeleting} // Disable during deletion
            type={ButtonTypes.primary}
            label={isDeleting ? trans('DELETING') : trans('YESDELETEGROUP')}
            icon={
              !isDeleting && (
                <NewUpdateIcon
                  style={{ fill: '#003252' }}
                  className={'create-group-icon-enabled'}
                />
              )
            }
            onClick={() => {
              groupDeleteHandler(record.groupuuid);
            }}
            loading={isDeleting} // Show loading spinner on button if supported
          />
        </div>
      </div>
    </Modal>
  );
};

export default GroupDeleteConfirmModal;
